export default "__VITE_ASSET__b1N37joH__"